import type { IconProps } from './types';

/**
 * 入力欄のパスワード表示切替（表示状態）用の目アイコン。16px・グレー。
 * ※ナビ用途の `IconEye`（30px・白）とは意匠/サイズが別物。ペアは `IconEyeOff`。
 */
export const IconEyeOpen = ({ width, height, color = '#A3A3A3', className }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M1.33333 8C1.33333 8 3.33333 3.33333 8 3.33333C12.6667 3.33333 14.6667 8 14.6667 8C14.6667 8 12.6667 12.6667 8 12.6667C3.33333 12.6667 1.33333 8 1.33333 8Z'
        stroke={color}
        strokeWidth='1.33'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z'
        stroke={color}
        strokeWidth='1.33'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
